module.exports = __webpack_public_path__ + "img/closed-loop-7.8ac9a6d1.png";